
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 18C3 9.716 9.615 3 17.775 3s14.776 6.716 14.776 15c0 8.284-6.615 15-14.776 15C9.615 33 3 26.284 3 18zm22.466-3.02s-.154-1.126-.626-1.622c-.599-.652-1.27-.655-1.577-.693-2.202-.165-5.506-.165-5.506-.165h-.006s-3.304 0-5.506.165c-.308.038-.978.041-1.577.693-.472.496-.625 1.623-.625 1.623s-.158 1.323-.158 2.646v1.24c0 1.324.158 2.647.158 2.647s.153 1.126.625 1.623c.599.651 1.385.63 1.735.698 1.26.126 5.351.165 5.351.165s3.307-.005 5.51-.17c.307-.039.977-.042 1.576-.693.472-.497.626-1.623.626-1.623s.157-1.323.157-2.646v-1.241c0-1.323-.157-2.646-.157-2.646zm-9.337 5.39v-4.593l4.252 2.305-4.252 2.289z","fill":"currentColor"}})])
          )
        }
      }
    